export default "__VITE_ASSET__CXDyMzNk__"